import _get from "lodash/get";
import { getCheckout, State as CheckoutState } from "./checkout";
import { CustomerType, MaybeEmpty } from "../../../../../constants";
import { EsimType } from "../../../../../models";
import { CustomerInfoState, LegalOwnerIndividual } from "../../../../../models/state";

export type State = CheckoutState;

export const getCustomerInfo = (state: State): MaybeEmpty<CustomerInfoState> => getCheckout(state).customerInfo || {};

export const isProductUserAgeOk = (state: State): boolean => !!getCustomerInfo(state).isProductUserAgeOk;
export const isProductUserDifferentThanLegalOwner = (state: State): boolean =>
    !!getCustomerInfo(state).isProductUserDifferentThanLegalOwner;
export const isCatalogListingOk = (state: State): boolean => !!getCustomerInfo(state).isCatalogListingOk;
export const isEsimSelected = (state: State): boolean => !!getCustomerInfo(state).isEsimSelected;
export const esimType = (state: State): EsimType => getCustomerInfo(state).esimType || "";
export const isBarringsUsed = (state: State): boolean => !!getCustomerInfo(state).isBarringsUsed;
export const isCampaignToggled = (state: State): boolean => !!getCustomerInfo(state).isCampaignToggled;
export const isCampaignAllowed = (state: State): boolean => !!getCustomerInfo(state).isCampaignAllowed;
export const hasValidSmartDiscount = (state: State): boolean => !!getCustomerInfo(state).hasValidSmartDiscount;
export const isSecretNumber = (state: State): boolean => !!getCustomerInfo(state).isSecretNumber;
export const isOptingOutForTeliaXServices = (state: State): boolean =>
    !!getCustomerInfo(state).isOptingOutForTeliaXServices;
export const isEmailTakenForTeliaTrygg = (state: State): boolean => !!getCustomerInfo(state).isEmailTakenForTeliaTrygg;
export const isEmailTakenForTeliaSky = (state: State): boolean => !!getCustomerInfo(state).isEmailTakenForTeliaSky;
export const isNotFound = (state: State): boolean => !!getCustomerInfo(state).isNotFound;
export const isZipNeeded = (state: State): boolean => !!getCustomerInfo(state).isZipNeeded;

// Legal Owner
export const getLegalOwner = (state: State): Partial<LegalOwnerIndividual> => getCustomerInfo(state).legalOwner || {};
export const getLegalOwnerEmail = (state: State): string => getLegalOwner(state).email || "";
export const hasLegalOwnerEmail = (state: State): boolean => !!getLegalOwnerEmail(state);
export const getLegalOwnerPhone = (state: State): string => getLegalOwner(state).phone || "";
export const getLegalOwnerFirstname = (state: State): string => getLegalOwner(state).firstName || "";
export const getLegalOwnerLastname = (state: State): string => getLegalOwner(state).lastName || "";
export const getLegalOwnerFullName = (state: State): string =>
    `${_get(getLegalOwner(state), "firstName", "")} ${_get(getLegalOwner(state), "lastName", "")}`.trim();
export const getLegalOwnerBirthdate = (state: State): string => getLegalOwner(state).birthDate || "";
export const getLegalOwnerPostcode = (state: State): string => getLegalOwner(state).postcode || "";
export const getLegalOwnerCity = (state: State): string => getLegalOwner(state).city || "";
export const getLegalOwnerFullCity = (state: State): string =>
    `${_get(getLegalOwner(state), "postcode", "")} ${_get(getLegalOwner(state), "city", "")}`.trim();
export const getLegalOwnerAddress = (state: State): string => getLegalOwner(state).street || "";

// Current
export const getCurrentType = (state: State): CustomerType | undefined => getCustomerInfo(state).currentType;
export const getCurrentIsPrepaidAndContainsPostpaid = (state: State): boolean =>
    !!getCustomerInfo(state).currentIsPrepaidAndContainsPostpaid;
export const getCurrentIsExistingPrepaidKBDSubscription = (state: State): boolean =>
    !!getCustomerInfo(state).currentIsExistingPrepaidKBDSubscription;
export const getCurrentIsExistingMissingEmail = (state: State): boolean =>
    getCustomerInfo(state).currentIsExistingMissingEmail || false;
export const getMaskedEmail = (state: State): string => getCustomerInfo(state).maskedEmail || "";
export const getCurrentCampaignIdsNotAllowed = (state: State): string[] | undefined =>
    getCustomerInfo(state).campaignIdsNotAllowed;
